import React, { Fragment, useState } from "react";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import { getDateFormat } from "../../components/common";

const WeekStateForm = ({ state, handleState }) => {
  return (
    <Fragment>
      <Row>
        <Col>
          <Form.Group controlId="dsuni-week-state">
            <Form.Label>상태</Form.Label>
            <Form.Select value={state ?? "none"} onChange={handleState}>
              <option value="none">none</option>
              <option value="open">open</option>
              <option value="close">close</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </Fragment>
  );
};

const WeekAuthForm = ({ auth, handleAuth }) => {
  return (
    <Form className="mb-3">
      <Form.Group controlId="dsuni-week-authcode">
        <Row>
          <Col>
            <Form.Label>인증 코드</Form.Label>
            <Form.Control
              placeholder="0000"
              name="code"
              value={auth.code}
              maxLength={4}
              onChange={handleAuth}
            />
          </Col>
          <Col>
            <Form.Label>시작일</Form.Label>
            <Form.Control
              type="date"
              name="beginDate"
              value={getDateFormat(auth.beginDate)}
              onChange={handleAuth}
            />
          </Col>
          <Col>
            <Form.Label>완료일</Form.Label>
            <Form.Control
              type="date"
              name="endDate"
              value={getDateFormat(auth.endDate)}
              onChange={handleAuth}
            />
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );
};

const CourseForm = ({ info }) => {
  return (
    <Fragment>
      <Alert variant="info">
        <Row>
          <Col>{info.courseNumber}</Col>
          <Col>{info.courseName}</Col>
          <Col>{info.classRoom}</Col>
          <Col>{info.classHour} 시</Col>
        </Row>
      </Alert>
    </Fragment>
  );
};

const WeekForm = ({ weekId, week, state, auth, handleSaveWeek }) => {
  const [btnSaveDirty, setBtnSaveDirty] = useState(false);
  const [weekState, setWeekState] = useState(state);
  const [weekAuth, setWeekAuth] = useState({
    code: auth.code,
    beginDate: auth.beginDate,
    endDate: auth.endDate,
  });

  const handleState = (e) => {
    const { value } = e.target;
    setWeekState(value);
    setBtnSaveDirty(true);
  };

  const handleAuth = (e) => {
    const { name, value } = e.target;
    setWeekAuth((cur) => {
      return { ...cur, [name]: value };
    });
    setBtnSaveDirty(true);
  };

  const handleSave = (e) => {
    handleSaveWeek({
      weekId,
      weekState,
      weekAuth,
    });
    setBtnSaveDirty(false);
  };

  return (
    <Fragment>
      <Alert className="p-2">
        <Row className="align-items-center">
          <Col>
            주차 : {(week-11) ?? undefined} <br />
          </Col>
          <Col className="col-2">
            <Button onClick={handleSave} disabled={!btnSaveDirty}>
              저장
            </Button>
          </Col>
        </Row>
      </Alert>
      <WeekStateForm state={weekState} handleState={handleState} />
      <WeekAuthForm auth={weekAuth} handleAuth={handleAuth} />
    </Fragment>
  );
};

export const ProfessorEditForm = ({ professor, handleSaveWeek }) => {
  return (
    <Fragment>
      {professor.courses.map((it, index) => {
        return (
          <Fragment key={index}>
            <hr />
            <CourseForm info={it.info} />
            {it.weeks.map((st, sIndex) => {
              return (
                <div key={sIndex}>
                  <WeekForm
                    weekId={st._id}
                    week={st.week}
                    state={st.state}
                    auth={st.auth}
                    handleSaveWeek={handleSaveWeek}
                  />
                </div>
              );
            })}
          </Fragment>
        );
      })}
      <hr />
    </Fragment>
  );
};
